import styled from 'styled-components';

export const SiteMapWrapper = styled.div`
 width: 100%;
 padding: 5px 10px 0px;
`;
